import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landingRedesign.scss";
import "../../Assets/Styles/pages/featuresPageRedesign.scss";
import Nav from "../../Components/LandingComponents/Nav";
import FeaturesHero from "../../Components/FeaturesPageComponents/FeaturesHero";
import KeyFeatures from "../../Components/FeaturesPageComponents/KeyFeatures";
import MoreFeaturesGrid from "../../Components/FeaturesPageComponents/MoreFeaturesGrid";
import FeaturesCTA from "../../Components/FeaturesPageComponents/FeaturesCTA";
import usePageMetadata from "../../Utils/usePageMetadata";

// The global Footer still renders below every route including this one. The global Header's
// desktop bar is suppressed for "/features" in Header.tsx's `condition()` -- Nav replaces it,
// same pattern as the landing page.
const Features: React.FC = () => {
  usePageMetadata(
    "Key Features - eZy WaterMark",
    "Explore key features of eZy Watermark app including template creation, batch watermarking, creative signatures, custom fonts, brand logo watermarking, and more."
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-redesign">
      <Nav />
      <FeaturesHero />
      <KeyFeatures />
      <MoreFeaturesGrid />
      <FeaturesCTA />
    </div>
  );
};

export default Features;
